const REGIONALIZATION = 'regionalization'

export default {
    REGIONALIZATION
}